// extracted by mini-css-extract-plugin
module.exports = {"faq":"FAQ_faq__fRV6u","none":"FAQ_none__goyXT"};